<template>
  <div>
    <p class="contentCode" v-html="content" />
  </div>
</template>

<script>
export default {
  name: 'CountDown',
  props: { // 接收父组件的数据
    endTime: { type: String, default: '' },
    endText: { type: String, default: '' }
  },
  data() {
    return {
      content: '',
      timer: null,
      hasEnded: false
    }
  },
  watch: { // 监听时间的变化
    'endTime': {
      handler(val) {
        this.clearTimer()
        this.hasEnded = false
        if (val) {
          this.countdowm(val)
        } else {
          this.content = this.endText
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    countdowm(timestamp) {
      const self = this;
      this.timer = setInterval(function() {
        const nowTime = new Date();
        const endTime = new Date(timestamp * 1000);
        const t = endTime.getTime() - nowTime.getTime();
        if (t > 1) {
          const day = Math.floor(t / 86400000);
          let hour = Math.floor((t / 3600000) % 24);
          let min = Math.floor((t / 60000) % 60);
          let sec = Math.floor((t / 1000) % 60);

          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          let format = '';
          if (day > 0) {
            format = `<span>${day}</span>天<span>${hour}</span>小时<span>${min}</span>分<span>${sec}</span>秒`;
          }
          if (day <= 0 && hour > 0) {
            format = `<span>${hour}</span>小时<span>${min}</span>分<span>${sec}</span>秒`;
          }
          if (day <= 0 && hour <= 0) {
            format = `<span>${min}</span>分<span>${sec}</span>秒`;
          }
          self.content = format;
        } else {
          self.clearTimer()
          if (!self.hasEnded) {
            self.hasEnded = true
            self.$emit('countEnd')
          }
          self.content = self.endText;
        }
      }, 1000);
    }
  }
}
</script>
<style>
.contentCode {
    display: flex;
    align-items: center;
    flex: 2;
    font-size: 16px;
    color: #5FCA71;
    justify-content: center;
}

.contentCode span {
    /* background-color: #F5BC41; */
    color: #5FCA71;
    font-size: 16px;
    /* width: 20px; */
    padding: 0 4px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    margin: 0 3px;
    border-radius: 2px;
}
</style>
